import { rest } from 'msw';

export default [
  rest.post('/api/token/validate', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        firstName: 'John',
        lastName: 'Done',
        validationToken: '123123123',
        captchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
      })
    );
  }),
];
